import LiveFilter from './LiveFilter';
const els = document.querySelectorAll('.js-live-filter');

for (let el of els) {
    LiveFilter(el);
}
